
export default {
    computed:{
        getCurrentRoles(){
            const user = JSON.parse(localStorage.getItem("user"));
            return user.user_role_assoc.map(item => item.id)
        }
    }
}